<template>
  <div class="advertisementContentWrapper">
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left">Advertisement List </h3>
          </b-card-header>
          <b-card-body>
            <b-table responsive="sm" :items="items" :fields="fields" :per-page="perPage" :busy="fetching">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(index)="data">
                {{ data.index+1 + ((currentPage-1)*perPage) }}
              </template>
              <template v-slot:cell(PreviewUrl)="data">
                <img :src="`${data.item.PreviewUrl}`" alt="" width="250px">
              </template>
              <template v-slot:cell(action)="data">
                <b-button variant="primary" class="mb-1" @click="downloadFile(data.item)"><i class="fa fa-download"></i></b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import VueNotifications from 'vue-notifications'
import { Events } from '../../../events'

export default {
  name: 'AdvertisementTable',
  data: () => {
    return {
      fetching: false,
      currentPage: 1,
      perPage: 20,
      items: [],
      fields: [
        {key: 'index', label: 'S.No'},
        {key: 'Name', label: 'Name'},
        {key: 'CategoryName', label: 'Category'},
        {key: 'Description', label: 'Description'},
        {key: 'PreviewUrl', label: 'Preview Banner'},
        {key: 'action', label: 'Action'}
      ]
    }
  },
  watch: {
    currentPage: function () {
      this.getAdvertisementList()
    }
  },
  created () {
    this.getAdvertisementList()
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    async getAdvertisementList () {
      try {
        this.fetching = true
        const payload = {
          page: this.currentPage,
          size: this.perPage
        }
        const { data: { list, rowCount } } = await this.$http.post(`${this.API_ENDPOINT}/api/v1/advertisement/banner/getList`, payload, { headers: { 'Content-Type': 'application/json' } })
        this.items = list
        this.rowCount = rowCount
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        setTimeout(() => {
          this.fetching = false
        }, 200)
      }
    },
    downloadFile (data) {
      const link = document.createElement('a')
      link.href = data.Url
      link.setAttribute('download', `${data.Name}.zip`)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Advertisement/AdvertisementTable.vue